import React from "react";
import Seo from "../components/Seo";
import Footer from "../components/Footer";
import Hero from "../components/Heros/HeroBusiness";
import Features from "../components/Features/FeatureICT";

const ICT = () => (
    <>
        <Seo
            title="ICT융합기술 R&D / 기술사업화"
            description="기존 산업에 접목할 수 있는 ICT 분야 융합기술과 시스템을 기획·개발·컨설팅하고, 대학 원천기술을 상용화합니다."
            path="/ICT"
        />
        <Hero />
        <Features />
        <Footer />
    </>
);

export default ICT;
